<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>消化行</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <el-input v-model="queryParams.id" placeholder="请输入ID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item">
                <el-input v-model="queryParams.number" placeholder="对象编码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item">
                <el-input v-model="queryParams.ppa_code" placeholder="PPA编码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item">
                <el-input
                    v-model="queryParams.performance_product_code"
                    placeholder="绩效产品编码"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="performance_unit_code"
                    model_name="请选择绩效单元"
                    :model_value_default="queryParams['performance_unit_code']"
                    request_uri="dropdownPerformanceUnit"
                    select_value="code"
                    @onDropChange="onDropChange"
                    ref="performance_unit_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <el-input
                    v-model="queryParams.performance_unit_name"
                    placeholder="请输入绩效单元名称"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item">
                <el-date-picker
                    v-model="queryParams['date_range']"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    size="small"
                    style="width: 300px"
                >
                </el-date-picker>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="performance_basis_code"
                    model_name="请选择绩效依据"
                    :model_value_default="queryParams['performance_basis_code']"
                    request_uri="dropdownPerformanceBasis"
                    :request_params="{ type: 'all' }"
                    select_value="value"
                    @onDropChange="onDropChange"
                    ref="performance_basis_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="partner_rid"
                    model_name="请选择合作方"
                    :model_value_default="queryParams['partner_rid']"
                    request_uri="dropdownPartners"
                    @onDropChange="onDropChange"
                    ref="partner_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="product_rid"
                    model_name="请选择产品"
                    :model_value_default="queryParams['product_rid']"
                    request_uri="dropdownProducts"
                    :request_params="{ type_code: [11, 15, 91] }"
                    @onDropChange="onDropChange"
                    ref="product_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vSearchSelect
                    model_key="account_rid"
                    model_name="请输入账户搜索"
                    request_uri="searchAccounts"
                    default_option_key="account_rid_option"
                    :default_option="queryParams['account_rid_option']"
                    @onDropChange="onDropChange"
                    ref="account_rid_ref"
                ></vSearchSelect>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="base_basis_code"
                    model_name="请选择基础基数依据"
                    select_value="value"
                    :model_value_default="queryParams['base_basis_code']"
                    request_uri="dropdownBaseBasis"
                    @onDropChange="onDropChange"
                    ref="base_basis_code_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item">
                <vDropdownMul
                    model_key="base_factor_sign"
                    model_name="请选择基数因子标识"
                    select_value="value"
                    request_uri="dropdownPerformanceBaseFactorSign"
                    :model_value_default="queryParams['base_factor_sign']"
                    @onDropChange="onDropChange"
                    ref="base_factor_sign_ref"
                ></vDropdownMul>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="recalculate()" :loading="btnLoading">重算消化行</el-button>
                <el-button size="small" plain @click="show_help()" icon="el-icon-question">帮助信息</el-button>

                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset">重置</el-button>
                    <el-button size="small" plain icon="el-icon-bottom" @click="getList(2)" :loading="down_loading">下载</el-button>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone"></draggableList>
                </div>
            </div>

            <div v-show="is_show_help">
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >重算消化行：重算2024年起的近3年的消化数据。计算过程依赖应收、清账、流向、流向扩展、流向状态等数据；计算过程中勿对依赖数据进行调整，否则计算结果可能产生偏差</span
                    >
                </div>
                <div class="flex" v-for="(item, index) in taskQueueMessage" :key="index">
                    <span style="color: red; font-size: 13px">
                        {{ item }}
                    </span>
                </div>
            </div>

            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="consumption_line"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div
                                v-if="
                                    in_array(item.prop, [
                                        'id',
                                        'performance_unit_name',
                                        'product',
                                        'performance_assignment_rid',
                                        'ppa_code',
                                        'partner',
                                        'account',
                                        'supplier',
                                        'demander',
                                        'representative'
                                    ])
                                "
                            >
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onDelete, onReSize, onSearch, in_array } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';
import crmUpload from '@/components/common/Upload.vue';
import vDropdownMul from '@/components/common/dropdown/dropdownMul.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        vSearchSelect,
        vDropdownMul,
        crmUpload
    },
    name: 'consumptionLineComponent',
    data() {
        return {
            is_show_help: false,
            draggable: {
                data_name: 'consumption_line'
            },
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {},
            taskQueueMessage: []
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
        this.initTaskQueueMessage();
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // this.getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        show_help() {
            this.is_show_help = this.is_show_help == false ? true : false;
        },
        initTaskQueueMessage() {
            this.$api['taskQueueMessage']({
                code: ['recalculate_consumption_line']
            })
                .then((res) => {
                    if (res.code == 0) {
                        this.taskQueueMessage = res.data;
                    }
                })
                .catch((error) => {
                    this.taskQueueMessage = [];
                });
        },
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['id']) && row.id) {
                this.$router.push({
                    path: '/consumptionLineDetail',
                    query: {
                        id: row.id
                    }
                });
            } else if (in_array(prop, ['performance_unit_name']) && row.performance_unit_id) {
                this.$router.push({
                    path: '/performanceUnitDetail',
                    query: {
                        id: row.performance_unit_id
                    }
                });
            } else if (in_array(prop, ['product']) && row.product_rid) {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: row.product_rid
                    }
                });
            } else if (in_array(prop, ['performance_assignment_rid']) && row.performance_assignment_rid) {
                this.$router.push({
                    path: '/performanceAssignmentDetail',
                    query: {
                        id: row.performance_assignment_rid
                    }
                });
            } else if (in_array(prop, ['ppa_code']) && row.ppa_rid) {
                this.$router.push({
                    path: '/partnerProductAccountDetail',
                    query: {
                        id: row.ppa_rid
                    }
                });
            } else if (in_array(prop, ['partner']) && row.partner_rid) {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.partner_rid
                    }
                });
            } else if (in_array(prop, ['account']) && row.account_rid) {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.account_rid
                    }
                });
            } else if (in_array(prop, ['supplier']) && row.supplier_rid) {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.supplier_rid
                    }
                });
            } else if (in_array(prop, ['demander']) && row.demander_rid) {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.demander_rid
                    }
                });
            } else if (in_array(prop, ['representative']) && row.representative_rid) {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.representative_rid
                    }
                });
            }
        },
        recalculate(type) {
            this.$confirm('您确定要进行重算吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    // 公用绩效重算接口
                    this.$api['performanceUnitRecalculate']({ type: 4 })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: res.data,
                                    type: 'success'
                                });
                                this.reload();
                            }
                            this.btnLoading = false;
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('consumption_line_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('consumption_line_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('consumption_line', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).consumption_line;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'consumptionLineLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            this.initQueryParams();
            this.$refs.performance_unit_code_ref.reset();
            this.$refs.performance_basis_code_ref.reset();
            this.$refs.partner_rid_ref.reset();
            this.$refs.product_rid_ref.reset();
            this.$refs.account_rid_ref.reset();
            this.$refs.base_basis_code_ref.reset();
            this.$refs.base_factor_sign_ref.reset();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>